import React from 'react'

// 🔴 PART 15c — THE MARK IN THE BAR IS THIS SITE'S OWN FAVICON.
//
// George, 24 September 2026, verbatim: *"making sure the favicon is the same icon used in the
// header"*. Until today the bar drew the shared five-circle family glyph while the favicon was
// this site's own padlock — two different drawings for one site, which is the fault the rule
// names. The bar now draws the favicon's own drawing, so the tab, the bookmark and the header
// are ONE icon. Part 3's construction is unchanged (full width, sticky, this site's own
// near-black at 0.82 through a blur, the hairline underneath, the label over
// NODEJAVASCRIPT.COM); only the GLYPH is the site's own.
//
// It is drawn ONCE here and used TWICE — the header brand and the footer's brand line — so the
// two can never drift into two different marks.
//
// 🔴 THE GEOMETRY IS THE FAVICON'S, VERBATIM — DO NOT "TIDY" THE NUMBERS. Part 15c is measured,
// by `svg_sig()` in `~/.nodejs_compliance.py`, from the RENDERED page: it compares this drawing
// with `public/favicon.svg` shape by shape — a circle by its centre, a rect and a path by their
// own commands — so a rounded coordinate, a rescaled rect or an added `fill` is a DIFFERENT
// drawing to that check. The one omission is the favicon's background plate (its `#0d1319`
// rounded square), because the bar is that kind of ground already and the plate would be a
// second dark square on a dark bar.
const Mark = ({ size = 22 }) => (
  <svg viewBox='0 0 64 64' width={size} height={size}>
    <rect x='20' y='28' width='24' height='18' rx='4' fill='#a78bfa' />
    <path
      d='M25 28v-5a7 7 0 0 1 14 0v5'
      fill='none'
      stroke='#a78bfa'
      strokeWidth='3.5'
      strokeLinecap='round'
    />
    <circle cx='32' cy='36' r='2.6' fill='#0d1319' />
    <rect x='30.8' y='38.5' width='2.4' height='4.5' rx='1.2' fill='#0d1319' />
  </svg>
)

export default Mark
